import React, { useMemo, useState } from "react";
import { Box, Container, Stack, Typography } from "@mui/material";

import { LanguageSelector } from "src/features";

import { privacyPolicyData } from "./model/constants";

export const PrivacyPolicy: React.FC = () => {
  const [language, setLanguage] =
    useState<keyof typeof privacyPolicyData>("us");

  const privacyData = useMemo(() => {
    return privacyPolicyData[language];
  }, [language]);

  const handleChangeLanguage = (value: keyof typeof privacyPolicyData) => {
    setLanguage(value);
  };

  return (
    <Box width={1} minHeight="100vh" bgcolor="background.default">
      <Container
        maxWidth="lg"
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          paddingY: 4,
          gap: 2,
        }}
      >
        <Stack
          width={1}
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          gap={2}
        >
          <Typography
            variant="h4"
            fontWeight={200}
            color="textSecondary"
            textTransform="uppercase"
          >
            {privacyData.title}
          </Typography>

          <LanguageSelector onChange={handleChangeLanguage} value={language} />
        </Stack>

        <Typography variant="body1" color="textSecondary" fontWeight={300}>
          {privacyData.updatedAt}
        </Typography>

        <Stack width={1} direction="column" gap={2}>
          {privacyData.content.map((contentItem, index) => (
            <Stack key={index} width={1} direction="column" gap={1}>
              <Typography variant="h5" color="primary.light" fontWeight={300}>
                {index + 1}. {contentItem.title}
              </Typography>

              <Typography
                variant="caption"
                color="textSecondary"
                fontWeight={200}
                whiteSpace="pre-line"
              >
                {contentItem.description}
              </Typography>
            </Stack>
          ))}
        </Stack>
      </Container>
    </Box>
  );
};
